

import React, { useEffect, useState } from "react";
import { Table, Select, Modal, Button, Tag, Card } from "antd";
import { ApiURL } from "../../../services/apiConstants";
import { post } from "../../../services/services";
import { ErrorToast } from "../../../widgets/AppToast";
import { formatDate } from "../../../utils/dateFormatter";


const AllIssues = () => {
  const [page_loader, set_page_loader] = useState(true);
  const [ship_id, set_ship_id] = useState(null);
  const [ship_table_list, set_ship_table_list] = useState([]);

  // separate lists
  const [bugs, setBugs] = useState([]);
  const [changeRequests, setChangeRequests] = useState([]);
  const [featureRequests, setFeatureRequests] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);

  /* ---------------- SHIP LIST API ---------------- */
  const SHIP_LIST_API = () => {
    const FORM_DATA = new FormData();
    post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
      if (res?.status === true) {
        set_ship_table_list(res?.ships || []);
        All_ISSUES_LIST_API(); // load all initially
      }
    });
  };

  /* ---------------- ALL ISSUES API ---------------- */
  const All_ISSUES_LIST_API = (shipId = null) => {
    set_page_loader(true);

    const FORM_DATA = new FormData();
    if (shipId) FORM_DATA.append("ship_id", shipId);

    post(ApiURL.all_issues_com, FORM_DATA)
      .then((res) => {
        if (res?.status === true) {
          setBugs(res?.data?.bugs || []);
          setChangeRequests(res?.data?.change_requests || []);
          setFeatureRequests(res?.data?.feature_requests || []);
          setFeedbacks(res?.data?.feedbacks || []);
        } else {
          ErrorToast("Error", res?.message);
        }
      })
      .finally(() => set_page_loader(false));
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  /* ---------------- Description Modal ---------------- */
  const [descrModal, setDescrModal] = useState({
    visible: false,
    text: "",
  });

  const showDescription = (record) => {
    setDescrModal({ visible: true, text: record.description });
  };

  /* ---------------- Attachment Modal ---------------- */
  const [attachmentModal, setAttachmentModal] = useState({
    visible: false,
    url: "",
  });

  // const showAttachment = (path) => {
  //   setAttachmentModal({
  //     visible: true,
  //     url: `${BASE_URL}${path}`,
  //   });
  // };

  const showAttachment = (path) => {
  setAttachmentModal({
    visible: true,
    url: path,
  });
};

  /* ---------------- Badge Styling ---------------- */
  const renderSeverity = (severity) => {
    const colorMap = {
      high: "red",
      medium: "orange",
      low: "green",
      important: "blue",
      nice_to_have: "purple",
      urgent: "red",
      critical: "red",
    };
    return <Tag color={colorMap[severity] || "default"}>{severity}</Tag>;
  };

  /* ---------------- Columns ---------------- */
  const getColumns = (idKey, severityKey = null) =>
    [
      {
        title: "ID",
        align: "center",
        render: (record) => record[idKey],
      },
      {
        title: "Title",
        dataIndex: "title",
        align: "center",
      },
      {
        title: "Description",
        align: "center",
        render: (record) => (
          <Button type="link" onClick={() => showDescription(record)}>
            View
          </Button>
        ),
      },
      {
        title: "Attachment",
        align: "center",
        render: (record) =>
          record?.attachment ? (
            <Button
              type="link"
              onClick={() => showAttachment(record.attachment)}
            >
              View
            </Button>
          ) : (
            "—"
          ),
      },
      severityKey
        ? {
            title: "Status",
            align: "center",
            render: (record) => renderSeverity(record[severityKey]),
          }
        : null,
      {
        title: "Created At",
        dataIndex: "created_at",
        align: "center",
        render: (text) => formatDate(text),
      },
      {
        title: "Ship Name",
        dataIndex: "ship_name",
        align: "center",
      },
    ].filter(Boolean);

  return (
    <div style={{ padding: "15px" }}>
      {/* Ship Selection */}
      <Card style={{ marginBottom: "20px" }}>
        <label>
          <b>Select Ship</b>
        </label>
        <Select
          style={{ width: "100%", marginTop: 6 }}
          value={ship_id}
          allowClear
          placeholder="All Ships"
          onChange={(value) => {
            set_ship_id(value);
            All_ISSUES_LIST_API(value);
          }}
        >
          {ship_table_list.map(
            (ship) =>
              !ship.soft_delete && (
                <Select.Option key={ship.id} value={ship.id}>
                  {ship.vessel_name}
                </Select.Option>
              )
          )}
        </Select>
      </Card>

      {/* Bugs */}
      <Card title={`🐞 Bugs (${bugs.length})`} bordered>
        <Table
          bordered
          columns={getColumns("bug_id", "severity")}
          dataSource={bugs}
          loading={page_loader}
          pagination={{ pageSize: 5 }}
          rowKey="id"
        />
      </Card>

      {/* Change Requests */}
      <Card
        title={`🔧 Change Requests (${changeRequests.length})`}
        bordered
        style={{ marginTop: 20 }}
      >
        <Table
          bordered
          columns={getColumns("request_id")}
          dataSource={changeRequests}
          loading={page_loader}
          pagination={{ pageSize: 5 }}
          rowKey="id"
        />
      </Card>

      {/* Feature Requests */}
      <Card
        title={`✨ Feature Requests (${featureRequests.length})`}
        bordered
        style={{ marginTop: 20 }}
      >
        <Table
          bordered
          columns={getColumns("feature_id", "priority")}
          dataSource={featureRequests}
          loading={page_loader}
          pagination={{ pageSize: 5 }}
          rowKey="id"
        />
      </Card>

      {/* Feedback */}
      <Card
        title={`💡 Feedbacks (${feedbacks.length})`}
        bordered
        style={{ marginTop: 20 }}
      >
        <Table
          bordered
          columns={getColumns("feedback_id")}
          dataSource={feedbacks}
          loading={page_loader}
          pagination={{ pageSize: 5 }}
          rowKey="id"
        />
      </Card>

      {/* Description Modal */}
      <Modal
        title="Description"
        open={descrModal.visible}
        footer={null}
        onCancel={() => setDescrModal({ visible: false, text: "" })}
      >
        <p>{descrModal.text}</p>
      </Modal>

      {/* Attachment Modal */}
      <Modal
        title="Attachment Preview"
        open={attachmentModal.visible}
        footer={null}
        width={700}
        onCancel={() => setAttachmentModal({ visible: false, url: "" })}
      >
        <img
          src={attachmentModal.url}
          alt="Attachment"
          style={{ width: "100%", borderRadius: "6px" }}
        />
      </Modal>
    </div>
  );
};

export default AllIssues;
 